import * as React from 'react'
import {connect} from 'react-redux'
import {ISidebarDispatcher} from '../../core/interfaces/dispatchers'
import {appSidebarDispatcher} from '../../dispatchers/appSidebarDispatcher'
import {IAppStore, IAppUser} from '../../interfaces/reducers'

interface ParentProps {
  navigationWidth: number
}

interface OwnProps {
  minimized: boolean
  selected: string
  user?: IAppUser
}

interface DispatchProps extends ISidebarDispatcher {}

type Props = DispatchProps & OwnProps & ParentProps

const manageURL = process.env.MANAGE_URL
const helpURL = process.env.HELP_URL

const SidebarNavigation = ({user, setMinimized, minimized, setSelected, selected, navigationWidth}: Props) => {
  return (
    <div className="code-sidebar-navigation" style={{minWidth: `${navigationWidth}px`}}>
      <div className="code-sidebar-navi-icon" onClick={() => setMinimized(!minimized)}>
        <i className="fas fa-angle-double-left" />
      </div>
      <div
        className={`code-sidebar-navi-icon${selected == 'basemapsControl' && !minimized ? ' selected' : ''}`}
        onClick={() => {
          setSelected('basemapsControl')
        }}
        title="Базови карти"
      >
        <img src="resources/icons/map.svg" width={38} height={38} style={{width: '38px'}} alt="" />
      </div>
      <div
        className={`code-sidebar-navi-icon${selected == 'layersControl' && !minimized ? ' selected' : ''}`}
        onClick={() => {
          setSelected('layersControl')
        }}
        title="Видими слоеве"
      >
        <img src="resources/icons/layers2.svg" width={38} height={38} style={{width: '38px'}} alt="" />
      </div>
      {user && !user.isArchImportUser ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'registers' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('registers')
          }}
          title="Регистри"
        >
          <img src="resources/icons/list-on-window2.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && (user.isAdmin || user.isRegAdmin || user.isCadAdmin || user.isOpuAdmin || user.isUndAdmin) ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'creator' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('creator')
          }}
          title="Създаване на нови"
        >
          <img src="resources/icons/addPoint2.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && user.isPrintUser ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'exportMapControl' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('exportMapControl')
          }}
          title="Експорт"
        >
          <img src="resources/icons/export-doc.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && (user.isAdmin || user.isRegAdmin) ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'importControl' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('importControl')
          }}
          title="Импорт"
        >
          <img src="resources/icons/import-doc.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && !user.isArchImportUser ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'regHistoryControl' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('regHistoryControl')
          }}
          title="Архив регулация"
        >
          <img src="resources/icons/archive.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && (user.isArchControl || user.isArchImportUser) ? (
        <div
          className={`code-sidebar-navi-icon${selected == 'archImport' && !minimized ? ' selected' : ''}`}
          onClick={() => {
            setSelected('archImport')
          }}
          title="Инвестиционни и териториални проекти"
        >
          <img src="resources/icons/doc-check.svg" width={38} height={38} style={{width: '38px'}} alt="" />
        </div>
      ) : null}
      {user && (user.isAdmin || user.isRegAdmin || user.isCadAdmin || user.isOpuAdmin || user.isUndAdmin) && (
        <a
          className={`code-sidebar-navi-icon`}
          href={manageURL}
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Управление на потребители"
        >
          <i className="fas fa-users-cog" style={{width: '32px'}} />
        </a>
      )}
      <a
        className={`code-sidebar-navi-icon`}
        href={helpURL}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Помощ"
      >
        <i className="fas fa-info" style={{width: '32px'}} />
      </a>
    </div>
  )
}

const mapStateToProps = (state: IAppStore) => ({
  minimized: state.sidebar.minimize,
  selected: state.sidebar.currentlySelected,
  user: state.userInfo.user
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {...appSidebarDispatcher})(
  SidebarNavigation
)
